import { http } from '@4beefopag/4bee-fopag-core/dist/services';
import axios from 'axios';

export const getBlob = async (url, options = {}) => {
  try {
    const { data } = await http.get(url, { ...options, responseType: 'blob' });
    return data;
  } catch (e) {
    if (e.response && e.response.data) {
      // Tratamento necessário para retornar a resposta em JSON ao invés de blob quando ocorre erro
      const responseAsText = await e.response.data.text();
      e.response.data = JSON.parse(responseAsText);
    }
    throw e;
  }
};

export const apiClient = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_V2_BASE_URL,
});

apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('fopag.auth.token');
  // eslint-disable-next-line no-param-reassign
  config.headers.Authorization = token ? `Bearer ${token}` : '';
  return config;
});

export const getBlobApiV2 = async (url, options = {}) => {
  try {
    const { data } = await apiClient.get(url, { ...options, responseType: 'blob' });
    return data;
  } catch (e) {
    if (e.response && e.response.data) {
      // Tratamento necessário para retornar a resposta em JSON ao invés de blob quando ocorre erro
      const responseAsText = await e.response.data.text();
      e.response.data = JSON.parse(responseAsText);
    }
    throw e;
  }
};

export const postBlobApiV2 = async (url, data, options = {}) => {
  try {
    const response = await apiClient.post(url, data, { ...options, responseType: 'blob' });
    return response.data;
  } catch (e) {
    if (e.response && e.response.data) {
      const responseAsText = await e.response.data.text();
      e.response.data = JSON.parse(responseAsText);
    }
    throw e;
  }
};

const handleAuthError = (error, { handleAuthenticationError, handleAuthorizationError }) => {
  const { response } = error;
  if (response && response.status === 401) {
    handleAuthenticationError();
    return Promise.reject(error);
  }

  if (response && response.status === 403) {
    let message = response.data && response.data.message;
    if (!message || message === 'Forbidden resource') {
      message =
        'Você não tem permissão para acessar este recurso. Entre em contato com o administrador para obter assistência.';
    }

    handleAuthorizationError(message);
    return Promise.reject(error);
  }

  return Promise.reject(error);
};

export const setupAuthErrorInterceptor = (options) => {
  http.interceptors.response.use(
    (response) => response,
    (error) => handleAuthError(error, options)
  );
  apiClient.interceptors.response.use(
    (response) => response,
    (error) => handleAuthError(error, options)
  );
};
